<div class="form-item" [ngClass]="{
    'flex-end': flexEnd,
    'height-auto': heightAuto,
    }">
    <ng-content></ng-content>
</div>
